import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import config from '../../config/app';

const Metadata = ({title, meta}) => (
  <Helmet
    title={`${config.name} - ${title}`}
    meta={[{name: 'description', content: `${config.name} - ${meta}`}]}
  />
);

Metadata.propTypes = {
  title: PropTypes.string.isRequired,
  meta: PropTypes.string.isRequired,
};

export default Metadata;
